import React, { useEffect, useMemo, useState } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import styles from "./DocumentPreview.module.css";
import Button from "react-bootstrap/Button";

const DocumentPreview = ({ pdf, excel, docs, exportAccess }) => {
  const [linkPdfFile, setLinkPdfFile] = useState({});
  useEffect(() => {
    if (pdf) {
      setLinkPdfFile({ uri: URL.createObjectURL(pdf), fileName: pdf.name });
    }
  }, [pdf]);

  const documents = useMemo(() => {
    if (linkPdfFile) {
      return [linkPdfFile];
    }
    return [];
  }, [linkPdfFile]);

  const handleExportButton = (event) => {
    event.preventDefault();
    const link = document.createElement("a");
    if (excel) {
      link.href = URL.createObjectURL(excel);
      link.download = excel.name;
    }
    if (docs) {
      link.href = URL.createObjectURL(docs);
      link.download = docs.name;
    }

    link.click();
  };

  return (
    <>
      {(excel || docs) && exportAccess && (
        <div
          onClick={(e) => handleExportButton(e)}
          className={styles["add-btn"]}
        >
          Экспортировать
        </div>
      )}
      {pdf && (
        <>
          <h5 className={styles["main-text"]}>
            {pdf.name.replace(/\.[^/.]+$/, "")}
          </h5>
          <DocViewer
            documents={documents}
            pluginRenderers={DocViewerRenderers}
          />
        </>
      )}
    </>
  );
};

export default DocumentPreview;
